import { axios } from "../../config/axios"

export const userViewedAdsAPI = {
    /**
   * All user viewed ads
   * @param {id} userViewedAdID - Ad ID from User Viewed sponsored ads
   * @returns {object}
   */
    patchUserViewedAds(userViewedAdID){
        return axios.patch(`/api/v3/brand_promotion_viewed_by_users/${userViewedAdID}`).then(resp => resp.data)
    }
}
